import React from "react";

import { faGripVertical } from "@fortawesome/pro-solid-svg-icons/faGripVertical";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";
import { defineMessages, useIntl } from "react-intl";

import styles from "./LayoutRowDragHandle.module.scss";

interface Props {
  className?: string;
  dragging: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  fixed?: boolean;
}

const messages = defineMessages({
  drag: {
    id: "settings.formLayouts.canvas.actions.dragHandle",
    defaultMessage: "Drag to reorder",
    description: "Tooltip Drag to reorder handle",
  },
  fixed: {
    id: "settings.formLayouts.canvas.actions.fixedPosition",
    defaultMessage: "This field cannot be moved or modified",
    description: "Tooltip fixed position fields",
  },
});

const LayoutRowDragHandle: React.FC<Props> = ({ className, dragging, dragHandleProps, fixed }) => {
  const intl = useIntl();

  const handleProps = fixed ? {} : dragHandleProps;
  const placement = fixed ? "topLeft" : "top";
  const title = fixed ? intl.formatMessage(messages.fixed) : intl.formatMessage(messages.drag);

  return (
    <div
      className={cn(
        styles.container,
        { [styles.fixed]: fixed, [styles.hidden]: dragging },
        className
      )}
    >
      <Tooltip
        destroyTooltipOnHide
        mouseEnterDelay={0.5}
        mouseLeaveDelay={0}
        overlayClassName={styles.tooltip}
        placement={placement}
        title={dragging ? null : title}
        trigger={dragging ? [] : ["hover"]}
      >
        <div className={styles.handle} {...handleProps} tabIndex={-1}>
          <FontAwesomeIcon icon={faGripVertical} />
        </div>
      </Tooltip>
    </div>
  );
};

export default LayoutRowDragHandle;
